import { Injectable } from "@angular/core";
import { Observable, observable, BehaviorSubject } from "rxjs";
import { HttpService } from "./http.service";

@Injectable({
    providedIn: "root",
})
export class AuthService {


    constructor(
        private http: HttpService,
    ) {

    }


    // to-store-token....
    loggedin() {
        return !!localStorage.getItem('core_spa_user_token');
    }


    login(data: any): Observable<any> {
        // console.log("data ===> ",data);

        return this.http.post("/account/login", data);
    }

    registration(data: any): Observable<any> {
        return this.http.post("/account/register", data);
    }

    getToken() {
        return localStorage.getItem("core_spa_user_token");
    }

    logout() {
        return localStorage.removeItem('core_spa_user_token')
    }

    getTodaySignals(): Observable<any> {
        return this.http.get("/TradeSignal/TodaySignals");
    }

    //contact us

    contact_us_form(data: any): Observable<any> {
        return this.http.put('/Message/', data)
    }


}
